import React, { ReactNode, SetStateAction } from 'react';

import ResetButton from '../../../../../common/filterTable/components/Buttons/ResetButton';
import SearchButton from '../../../../../common/filterTable/components/Buttons/SearchButton';
import Filters from '../../../../../common/filterTable/components/Filters/Filters';
import FilterActions from '../../../../../common/filterTable/layout/FilterActions';
import FilterGrid from '../../../../../common/filterTable/layout/FilterGrid';
import DaIdAutoCompleteFilter from '../../../../../components/DaIdAutoCompleteFilter';
import { useGenFilterField } from '../../../../../utils/ComponentHelper';
import { FilterFields, FilterFieldsKeys } from '../../types/FilterFields';
import { useTranslation } from 'src/hooks';
import { translatePrefix } from '../..';
import ProgramNameSingleSelection from 'src/common/filterTable/components/Filters/ProgramNameSingleSelection';
import VipLevelSingleSelection from 'src/common/filterTable/components/Filters/VipLevelSingleSelection';
import KycLevelSingleSelection from 'src/common/filterTable/components/Filters/KycLevelSingleSelection';
import IdvMethodSingleSelection from 'src/common/filterTable/components/Filters/IdvMethodSingleSelection';
import SupportedSystemSingleSelection from 'src/common/filterTable/components/Filters/SupportedSystemSingleSelection';
import SourceSingleSelection from 'src/common/filterTable/components/Filters/SourceSingleSelection';
import ReferralCodeTextField from './components/ReferralCodeTextField';
import ReferralCodeStatusSingleSelection from './components/ReferralCodeStatusSingleSelection';

interface FilterSectionProps {
  fields: FilterFields;
  setFields: React.Dispatch<SetStateAction<FilterFields>>;
  onSearch: () => void;
  onReset: () => void;
  DateObj: any;
}

const FilterSection = (props: FilterSectionProps) => {
  const { fields, setFields, onSearch, onReset, DateObj } = props;

  const { tc, t } = useTranslation(translatePrefix);

  const updateField = (fieldName: string, value: any) => {
    setFields((fields) => {
      return {
        ...fields,
        [fieldName]: value,
      };
    });
  };

  const filterFields: ReactNode[] = useGenFilterField([
    ['creationTime', <DateObj.CreationTime.Picker type="dateTime" />],
    ['lastModifiedTime', <DateObj.LastModifiedTime.Picker type="dateTime" />],
    [
      FilterFieldsKeys.ProgramName,
      <ProgramNameSingleSelection
        value={fields[FilterFieldsKeys.ProgramName]}
        onChange={(e) => updateField(FilterFieldsKeys.ProgramName, e.target.value)}
        onClear={() => updateField(FilterFieldsKeys.ProgramName, '')}
      />,
    ],
    [
      FilterFieldsKeys.ReferralCode,
      <ReferralCodeTextField
        value={fields[FilterFieldsKeys.ReferralCode]}
        onChange={(e) => updateField(FilterFieldsKeys.ReferralCode, e.target.value)}
      />,
    ],

    [
      FilterFieldsKeys.DistributorAgentId,
      <DaIdAutoCompleteFilter
        value={fields[FilterFieldsKeys.DistributorAgentId]}
        onChange={(value) => updateField(FilterFieldsKeys.DistributorAgentId, value)}
        onClear={() => updateField(FilterFieldsKeys.DistributorAgentId, '')}
      />,
    ],
    [
      FilterFieldsKeys.IdvMethod,
      <IdvMethodSingleSelection
        value={fields[FilterFieldsKeys.IdvMethod]}
        onChange={(e) => updateField(FilterFieldsKeys.IdvMethod, e.target.value)}
        onClear={() => updateField(FilterFieldsKeys.IdvMethod, '')}
      />,
    ],
    [
      FilterFieldsKeys.ReferralCodeStatus,
      <ReferralCodeStatusSingleSelection
        value={fields[FilterFieldsKeys.ReferralCodeStatus]}
        onChange={(e) => updateField(FilterFieldsKeys.ReferralCodeStatus, e.target.value)}
        onClear={() => updateField(FilterFieldsKeys.ReferralCodeStatus, '')}
      />,
    ],
    [
      FilterFieldsKeys.VipLevel,
      <VipLevelSingleSelection
        value={fields[FilterFieldsKeys.VipLevel]}
        onChange={(e) => updateField(FilterFieldsKeys.VipLevel, e.target.value)}
        onClear={() => updateField(FilterFieldsKeys.VipLevel, '')}
      />,
    ],
    [
      FilterFieldsKeys.ConsumedSupportedSystem,
      <SupportedSystemSingleSelection
        value={fields[FilterFieldsKeys.ConsumedSupportedSystem]}
        onChange={(value) => updateField(FilterFieldsKeys.ConsumedSupportedSystem, value)}
        onClear={() => updateField(FilterFieldsKeys.ConsumedSupportedSystem, [])}
      />,
    ],

    [
      FilterFieldsKeys.Source,
      <SourceSingleSelection
        value={fields[FilterFieldsKeys.Source]}
        onChange={(e) => updateField(FilterFieldsKeys.Source, e.target.value)}
        onClear={() => updateField(FilterFieldsKeys.Source, '')}
      />,
    ],
    [
      FilterFieldsKeys.KycLevel,
      <KycLevelSingleSelection
        value={fields[FilterFieldsKeys.KycLevel]}
        onChange={(e) => updateField(FilterFieldsKeys.KycLevel, e.target.value)}
        onClear={() => updateField(FilterFieldsKeys.KycLevel, '')}
      />,
    ],
  ]);

  return (
    <>
      <FilterGrid>
        <Filters filterFields={filterFields} />
      </FilterGrid>
      <FilterActions>
        <SearchButton onSearch={onSearch} />
        <ResetButton onReset={onReset} />
      </FilterActions>
    </>
  );
};

export default FilterSection;
